import React from "react";
import InvalidFeedback from "../InvalidFeedback";

export default React.forwardRef(( { type= 'text', optional= false, label, errors, currentLength, maxLength, children, sizeClass = 'form-control-lg', ...register }: any, ref) => {

    return  (
        <>
            { label && <label className="form-label" >{label} { optional && <span className="form-label-secondary">(Opcional)</span>}</label>}
            <div className={'d-flex ' + (errors ? 'is-invalid' : '')}>
                <input type={type} ref={ref} className={'form-control ' + (sizeClass) + (errors ? ' is-invalid ' : '')} {...register} />
                {children}
            </div>
        
            <InvalidFeedback error={errors} />

            {
                maxLength && maxLength > 0 && (<div className="form-text mt-1 text-end">{currentLength}/{maxLength}</div>)
            }
        </>
    )
}
)